module.exports = __webpack_public_path__ + "img/grasse_4.bf56faf9.png";